import { useState, useEffect } from "react";
import { Bars3Icon } from "@heroicons/react/24/outline";

const HeaderHome = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className="bg-gradient-to-r from-gray-900 via-black to-gray-900 text-white">
      <header
        className={`fixed top-0 inset-x-0 z-50 w-full transition-all duration-300 ${
          scrolled ? "bg-slate-950" : "bg-opacity-70"
        } shadow-xl border-b border-white/10`}
      >
        <nav
          aria-label="Global"
          className="flex items-center justify-between p-6 lg:px-8"
        >
          <div className="flex lg:flex-1">
            <a href="/" className="-m-1.5 p-1.5">
              <span className="sr-only">Delta Servis</span>
              <img alt="Logo" src="/logo.png" className="h-8 w-auto" />
            </a>
            <div className="pl-5">
              <button
                onClick=""
                className="lg:hidden rounded-lg bg-red-600 px-1 py-2 text-base font-semibold text-white shadow-md transition-all duration-300 hover:scale-105 hover:bg-red-700 hover:shadow-lg"
              >
                Şimdi Katıl
              </button>
            </div>
          </div>

          <div className="flex lg:hidden">
            <button
              type="button"
              onClick={() => setMobileMenuOpen(true)}
              className="rounded-md bg-gray-800 p-2.5 text-white transition-transform duration-300 hover:scale-105 hover:bg-gray-700 hover:shadow-lg"
            >
              <span className="sr-only">Menü</span>
              <Bars3Icon className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>
          {mobileMenuOpen && (
            <div className="fixed inset-0 z-50 bg-gray-800 bg-opacity-90">
              <div className="absolute top-4 right-4">
                <button
                  type="button"
                  onClick={() => setMobileMenuOpen(false)}
                  className="rounded-md bg-red-600 p-3 text-white hover:bg-red-700"
                >
                  <span className="sr-only">Kapat</span>X
                </button>
              </div>
              <nav className="flex flex-col items-center justify-center h-full text-white space-y-4">
                <a href="/" className="text-lg font-bold hover:underline">
                  Telefon
                </a>
                <a href="/" className="text-lg font-bold hover:underline">
                  Tablet
                </a>
                <a href="/" className="text-lg font-bold hover:underline">
                  Bilgisayar
                </a>
                <a href="/" className="text-lg font-bold hover:underline">
                  Akıllı Saat
                </a>
                <a href="/" className="text-lg font-bold hover:underline">
                  Diğer
                </a>
              </nav>
            </div>
          )}

          <div className="hidden lg:flex lg:gap-x-1">
            <div className="flex items-center">
              <a
                href="/"
                className="text-lg rounded-md px-3 py-2 font-bold transition-all duration-300 hover:scale-125 hover:text-white"
              >
                Telefon
              </a>
              <span className="h-5 w-px bg-gray-400 mx-4"></span>
            </div>
            <div className="flex items-center">
              <a
                href="/"
                className="text-lg rounded-md px-3 py-2 font-bold transition-all duration-300 hover:scale-125 hover:text-white"
              >
                Tablet
              </a>
              <span className="h-5 w-px bg-gray-400 mx-4"></span>
            </div>
            <div className="flex items-center">
              <a
                href="/"
                className="text-lg rounded-md px-3 py-2 font-bold transition-all duration-300 hover:scale-125 hover:text-white"
              >
                Bilgisayar
              </a>
              <span className="h-5 w-px bg-gray-400 mx-4"></span>
            </div>
            <div className="flex items-center">
              <a
                href="/"
                className="text-lg rounded-md px-3 py-2 font-bold transition-all duration-300 hover:scale-125 hover:text-white"
              >
                Akıllı Saat
              </a>
              <span className="h-5 w-px bg-gray-400 mx-4"></span>
            </div>
            <div className="flex items-center">
              <a
                href="/"
                className="text-lg rounded-md px-3 py-2 font-bold transition-all duration-300 hover:scale-125 hover:text-white"
              >
                Diğer
              </a>
            </div>
          </div>

          <div className="hidden lg:flex lg:flex-1 lg:justify-end space-x-4">
            <button className="rounded-lg bg-blue-900 px-4 py-2 text-sm font-semibold shadow-lg hover:bg-blue-700">
              Üye Ol
            </button>
          </div>
        </nav>
      </header>
    </div>
  );
};

export default HeaderHome;
